module.exports = __webpack_public_path__ + "static/pallet-5049aac1957765b0915ebb535f9b905f.jpeg";